import { Text, View } from '@react-pdf/renderer';

import { PDFQuoteLinePartType } from '../../../PDFProvider';
import { styles } from '../styles';

type Part = Pick<
  PDFQuoteLinePartType,
  'partId' | 'customerPartId' | 'createdBySnap'
>;

type PartIdProps = {
  part: Part;
  showCustomerPartId?: boolean;
  showSnapPartId?: boolean;
};

export function buildPartIdText({
  part,
  showSnapPartId = false,
}: {
  part: Pick<Part, 'partId' | 'createdBySnap'>;
  showSnapPartId: boolean;
}) {
  if (part.createdBySnap) {
    if (showSnapPartId) {
      return part.partId;
    }

    return null;
  }

  return part.partId;
}

function PartIdText(props: { part: Part; showSnapPartId: boolean }) {
  const partId = buildPartIdText(props);

  if (!partId) {
    return null;
  }

  return <Text style={[styles.bold, { paddingBottom: '4px' }]}>{partId}</Text>;
}

export function buildCustomerPartIdText({
  part,
  showCustomerPartId = false,
}: {
  part: Pick<Part, 'customerPartId'>;
  showCustomerPartId: boolean;
}) {
  if (part.customerPartId && showCustomerPartId) {
    return part.customerPartId;
  }

  return null;
}

function CustomerPartIdText(props: {
  part: Pick<Part, 'customerPartId'>;
  showCustomerPartId: boolean;
}) {
  const customerPartId = buildCustomerPartIdText(props);

  if (!customerPartId) {
    return null;
  }

  return (
    <Text style={{ paddingBottom: '4px' }}>
      Customer Part: <Text style={[styles.bold]}>{customerPartId}</Text>
    </Text>
  );
}

export function PartId({
  part,
  showCustomerPartId = false,
  showSnapPartId = false,
}: PartIdProps) {
  return (
    <View>
      <PartIdText part={part} showSnapPartId={showSnapPartId} />
      <CustomerPartIdText part={part} showCustomerPartId={showCustomerPartId} />
    </View>
  );
}
